import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '@spartacus/asm/root';
import {
  BASE_SITE_CONTEXT_ID,
  BaseSiteService,
  OCC_USER_ID_ANONYMOUS,
  OccConfig,
  OccEndpointsService,
  UserIdService,
  WindowRef,
  getContextParameterDefault,
} from '@spartacus/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, retry, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class B2bUserService {
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  _activeBaseSite: string;
  asmEnabled = this.winRef.localStorage.getItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
  private cachedBasestoreData$: any = {};

  constructor(
    protected http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private meta: Meta,
    private authService: UserIdService,
    protected baseService: BaseSiteService,
    private config: OccConfig,
    private winRef: WindowRef
  ) {
    if (this.baseService) {
      this.baseService.getActive().subscribe((value) => (this._activeBaseSite = value));
    }
  }

  get activeBaseSite(): string {
    return this._activeBaseSite ?? getContextParameterDefault(this.config, BASE_SITE_CONTEXT_ID);
  }

  getB2bUserProfile(): Observable<any> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('fields', 'FULL');

    const httpOptions = {
      headers: this.headers,
      params: httpParams,
    };

    return this.authService
      .getUserId()
      .pipe(
        switchMap((userId: string) => {
          if (userId !== OCC_USER_ID_ANONYMOUS) {
            if (this.asmEnabled) {
              const checkBaseSite = userId.split(':');
              if (checkBaseSite.length > 1) {
                if (this.activeBaseSite.toLowerCase() !== 'shimano' + checkBaseSite[0] + '-' + checkBaseSite[1]) {
                  return of({});
                }
              }
            }
            return this.http.get(this.occEndpointsService.buildUrl(`/users/${userId}`), httpOptions);
          } else {
            return of({});
          }
        })
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  errorHandl(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
